import classNames from 'clsx'
import { bool, func, number, string } from 'prop-types'

import LoadingIndicator from 'views/components/atoms/LoadingIndicator'
import { DELIMITER } from 'views/components/molecules/Pagination/helpers'
import { usePaginationChangePage } from 'views/components/molecules/Pagination/usePaginationChangePage'
import { withSearchStateAndUrlContext } from 'views/enhancers/withSearchStateAndUrlContext'
import { getPaginationUrl } from 'views/utils/pagination'

import './PaginationItem.scss'

const PaginationItem = props => {
  const {
    label,
    isCurrent,
    onClick,
    pageNum,
    scrollToTopAfterClick,
    searchUrl,
  } = props

  const { onHandleChangePage, isLoadingAndIsRebranding } =
    usePaginationChangePage({
      handler: onClick,
      pageNum,
      scrollToTopAfterEvent: scrollToTopAfterClick,
    })

  const itemClassName = classNames('l-flex m-PaginationItem', {
    'm-PaginationItem--current': isCurrent,
    'm-PaginationItem--delimiter': label === DELIMITER,
    'm-PaginationItem--loading': isLoadingAndIsRebranding,
  })

  let href = pageNum > 1 ? `?pageNumber=${pageNum}` : '?'
  if (searchUrl) {
    href = getPaginationUrl(searchUrl, pageNum)
  }

  const content = isCurrent ? (
    <>
      <span className="u-visuallyhidden">Go to page </span>
      {label}
    </>
  ) : (
    <a
      onClick={onHandleChangePage}
      href={href}
      className="a-Button m-ButtonAsLink"
    >
      <span className="u-visuallyhidden">Go to page </span>
      {isLoadingAndIsRebranding ? (
        <LoadingIndicator color="white" size={20} />
      ) : (
        label
      )}
    </a>
  )

  return <div className={itemClassName}>{content}</div>
}

PaginationItem.propTypes = {
  pageNum: number.isRequired,
  label: string.isRequired,
  isCurrent: bool.isRequired,
  onClick: func,
  scrollToTopAfterClick: bool,
  searchUrl: string,
}

PaginationItem.defaultProps = {
  onClick: null,
  scrollToTopAfterClick: false,
  searchUrl: null,
}

export default withSearchStateAndUrlContext(PaginationItem)
